import { render } from "./CommentSection.vue?vue&type=template&id=6af6f462&scoped=true&ts=true"
import script from "./CommentSection.vue?vue&type=script&lang=ts"
export * from "./CommentSection.vue?vue&type=script&lang=ts"

import "./CommentSection.vue?vue&type=style&index=0&id=6af6f462&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af6f462"],['__file',"src/components/CommentSection/CommentSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6af6f462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6af6f462', __exports__)) {
    console.log('reload')
    api.reload('6af6f462', __exports__)
  }
  
  module.hot.accept("./CommentSection.vue?vue&type=template&id=6af6f462&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6af6f462', render)
  })

}


export default __exports__